
import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Sgke092aResponseSearchresultList } from 'sg-api';
import { Sgke050dDialogComponent } from '../../../sgke050d/components/sgke050d-dialog/sgke050d-dialog.component';

@Component({
  selector: 'app-sgke090d-result',
  templateUrl: './sgke090d-result.component.html',
  styleUrl: './sgke090d-result.component.scss'
})
export class Sgke090dResultComponent implements OnInit, OnDestroy {

  /** 検索結果リスト */
  @Input() searchresultList: Array<Sgke092aResponseSearchresultList>;

  /** 承認ボタン押下イベント */
  @Output() onClickApprovalEvent = new EventEmitter();

  /** メッセージエリアクリアエミッター */
  @Output() clearMessageEmit = new EventEmitter();
  /** ダブルクリックEmitter */
  @Output() onDblClickFlgEmitter = new EventEmitter();
  /** データソース */
  dataSource: MatTableDataSource<Sgke092aResponseSearchresultList>;

  @ViewChild('paginator1', { static: true }) paginator: MatPaginator;
  @ViewChild('sort1', { static: true }) sort: MatSort;

  /** MatDialogRef */
  ref: MatDialogRef<Sgke050dDialogComponent>;

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'regist',
    'businessClsfy',
    'apprvJokyo',
    'apprvReqYearmonthdate',
    'payCtrNo',
    'visitName',
    'rcvmnyNo',
    'receivemoneydate',
    'inmny',
    'kinkoAmt',
    'jikaiClaimPlndate',
    'rcvmnyKeitai',
    'kinkoReason',
    'kouzaReg',
    'effectCtrUmu',
    'transferdestinationPaymentcontractNo',
    'transferdestinationClmtoMei',
    'funoReason',
    'trnTntsh',
  ];

  /** 選択した行の情報 */
  selection: SelectionModel<Sgke092aResponseSearchresultList> = new SelectionModel<Sgke092aResponseSearchresultList>(true, []);

  /** 返金内容確認ボタン活性フラグ */
  isRepayStatus: boolean = false;
  /** 承認ボタン活性フラグ */
  isApproval: boolean = false;
  /** 業務種別：返金 */
  private static readonly S300471_repay: string = "3";

  /**
   * コンストラクタ
   * @param {MatDialog} dialog
   * @param {Router} router
   * @memberof Sgke090dResultComponent
   */
  constructor(
    public dialog: MatDialog,
    private router: Router,
  ) { };

  /**
   * 初期処理
   * @memberof Sgke090dResultComponent
   */
  ngOnInit(): void {
    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke092aResponseSearchresultList>(this.searchresultList);
  }

  /**
   * ViewInit後の呼び出し
   * @memberof Sgke090dResultComponent
   */
  ngAfterViewInit() {
    this.dataSource.paginator ??= this.paginator;
    this.dataSource.sort ??= this.sort;
  }

  /**
   * 購読解除
   * @memberof Sgke090dComponent
   */
  ngOnDestroy() {
  }

  /**
   * 行ダブルクリック時処理
   * @param {*} row
   * @memberof Sgke090dResultComponent
   */
  onDblClickRow(row: Sgke092aResponseSearchresultList, event?: MouseEvent) {
    
    this.onDblClickFlgEmitter.emit();
    // anyタイプのパラメータ
    const url:string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;
    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = row.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;
    // 入金番号
    let paymentNo: string = row.rcvmnyNo;
    // パラメータ設定
    // お客さま番号
    if(customerNo){
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if(paymentContractNo){
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 入金番号
    if(paymentNo){
      paramToOutside.c__paymentNo = paymentNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '4';
    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };
    // 別タブで該当URLを開く
    window.open(`${url}${params}`, '_blank');
    event?.stopPropagation();
  }

  /**
   * 返金内容確認ボタン押下時処理
   * @memberof Sgke090dResultComponent
   */
  onClickRepayInfo() {
    this.clearMessageEmit.emit();

    let data = this.selection.selected.map(row => {
      return {
        kinkoMno: row.kinkoMno,
        kinkoRrkno: row.kinkoRrkno,
        repayMno: row.repayMno,
        recptFixNo: row.payCtrNo,
        kinkoUpdateSrno: row.kinkoUpdateSrno,
        kinkoexUpdatesequencenumber: row.kinkoexUpdatesequencenumber
      }
    })[0];

    this.ref = this.dialog.open(Sgke050dDialogComponent, {
      height: '950px',
      width: '1000px',
      disableClose: true, // 背景クリックのクローズ禁止
      data: data,
    });
  }

  /**
   * 承認ボタン押下時処理
   * @memberof Sgke090dResultComponent
   */
  onClickApproval(): void {
    // 選択レコードリストを引数に入れて親コンポーネントへ通知
    this.onClickApprovalEvent.emit(this.selection.selected);
  }

  /**
   * 選択行の値チェック
   * @memberof Sgke090dResultComponent
   */
  onChangeRegist() {
    // 業務種別が「返金」の行が、1行のみ選択されている
    const repayStat = this.selection.selected.every(row => {
      return (row.kinkoBusinessClscode == Sgke090dResultComponent.S300471_repay)
    });
    this.isRepayStatus = (repayStat && this.selection.selected.length == 1);

    // 未精算ステータス=(返金依頼 OR 振替依頼 OR 不能依頼)の行のみ選択されている
    const kinkoStat = this.selection.selected.every(row => {
      return (row.kinkoStatuscode == "04" || row.kinkoStatuscode == "06" || row.kinkoStatuscode == "08");
    });
    this.isApproval = (kinkoStat && this.selection.selected.length > 0);
  }
}

